<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<zop-empty-layout *ngIf="layout === 'empty'"></zop-empty-layout>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with horizontal navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Centered -->
<zop-centered-layout *ngIf="layout === 'centered'" [config]="config"></zop-centered-layout>

<!-- Enterprise -->
<zop-enterprise-layout *ngIf="layout === 'enterprise'" [config]="config"></zop-enterprise-layout>

<!-- Material -->
<zop-material-layout *ngIf="layout === 'material'" [config]="config"></zop-material-layout>

<!-- Modern -->
<zop-modern-layout *ngIf="layout === 'modern'" [config]="config"></zop-modern-layout>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with vertical navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Classic -->
<zop-classic-layout *ngIf="layout === 'classic'" [config]="config"></zop-classic-layout>

<!-- Classy -->
<zop-classy-layout *ngIf="layout === 'classy'" [config]="config"></zop-classy-layout>

<!-- Compact -->
<zop-compact-layout *ngIf="layout === 'compact'" [config]="config"></zop-compact-layout>

<!-- Dense -->
<zop-dense-layout *ngIf="layout === 'dense'" [config]="config"></zop-dense-layout>

<!-- Futuristic -->
<zop-futuristic-layout *ngIf="layout === 'futuristic'" [config]="config"></zop-futuristic-layout>

<!-- Thin -->
<zop-thin-layout *ngIf="layout === 'thin'" [config]="config"></zop-thin-layout>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Settings drawer - Remove this to remove the drawer and its button -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- <zop-settings></zop-settings> -->